import vkBridge from "@vkontakte/vk-bridge";
import { subscribe } from "../services/subscription";

// handleSubscribe инкапсулирует полный процесс подписки пользователя:
// 1. Запрашивает разрешение на отправку уведомлений через VK Bridge.
// 2. В случае успеха, отправляет запрос на наш бэкенд для сохранения подписки.
export function handleSubscribe() {
    return new Promise((resolve, reject) => {
        vkBridge.send('VKWebAppAllowMessagesFromGroup', {
            group_id: parseInt(process.env.REACT_APP_VK_GROUP_ID),
        })
        .then(result => {
            if (result.result) {
                // Пользователь разрешил отправку, вызываем наш бэкенд
                return subscribe()
                    .then(() => {
                        resolve(true); // Успешная подписка
                    })
                    .catch(err => {
                        // Обработка ошибки бэкенда
                        console.error('Backend subscription error:', err);
                        reject(err);
                    });
            } else {
                // Пользователь отклонил запрос в диалоге VK
                reject({ message: "User denied subscription in VK dialog" });
            }
        })
        .catch(error => {
            // Ошибка от VK Bridge
            console.error('VKBridge error:', error);
            reject(error);
        });
    });
}
